import { render, staticRenderFns } from "./NowPlaying.vue?vue&type=template&id=2a700d38&"
import script from "./NowPlaying.vue?vue&type=script&lang=js&"
export * from "./NowPlaying.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports